<template>
  <div class="title t-h1 u-center">
    {{ text }}
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="stylus">

.title
  position absolute
  top 20px
  width 50%
  left 25%

</style>